var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["emp.empCmsEntrance.entranceCode"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["common.pleaseInput"] +
                                this.language["emp.empCmsEntrance.entranceCode"]
                            },
                            model: {
                              value: _vm.model.entranceCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "entranceCode", $$v)
                              },
                              expression: "model.entranceCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["emp.empCmsEntrance.entranceName"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "entranceName"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "85%" },
                            attrs: {
                              placeholder:
                                this.language["common.pleaseInput"] +
                                this.language["emp.empCmsEntrance.entranceName"]
                            },
                            model: {
                              value: _vm.model.entranceName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "entranceName", $$v)
                              },
                              expression: "model.entranceName"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "3%" },
                              attrs: { type: "primary", disabled: false },
                              on: {
                                click: function($event) {
                                  return _vm.languageModelOpen(
                                    "EmpCmsEntrance",
                                    "entranceName",
                                    _vm.entranceNameLanguages
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.language["common.language"]))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["emp.empCmsEntrance.description"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "description"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["common.pleaseInput"] +
                                this.language["emp.empCmsEntrance.description"]
                            },
                            model: {
                              value: _vm.model.description,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "description", $$v)
                              },
                              expression: "model.description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["emp.empCmsEntrance.setManager"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              on: { change: _vm.setManagerChange },
                              model: {
                                value: _vm.isSetManager,
                                callback: function($$v) {
                                  _vm.isSetManager = $$v
                                },
                                expression: "isSetManager"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: "Y" } }, [
                                _vm._v(_vm._s(_vm.language["common.yes"]))
                              ]),
                              _c("a-radio", { attrs: { value: "N" } }, [
                                _vm._v(_vm._s(_vm.language["common.no"]))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isSetManager == "Y",
                          expression: "isSetManager=='Y'"
                        }
                      ],
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-left": "16%",
                            "padding-right": "13%"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                border: "1px solid #262626",
                                "border-radius": "5px",
                                padding: "10px"
                              }
                            },
                            [
                              _c("emp-entrance-manager-user-form", {
                                ref: "entranceManagerUserForm",
                                on: { ok: _vm.close }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.empCmsEntrance.status"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              "trigger-change": true,
                              dictCode: "emp_entrance_status"
                            },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.empCmsEntrance.sortNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder:
                                this.language["common.pleaseInput"] +
                                this.language["emp.empCmsEntrance.sortNo"]
                            },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["emp.empCmsEntrance.remark"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                this.language["common.pleaseInput"] +
                                this.language["emp.empCmsEntrance.remark"]
                            },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }